import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

// 공통 컴포넌트
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

// 페이지 컴포넌트
import Home from './pages/Home';
import MissingPersonsPage from './pages/MissingPersonsPage';
import DisasterMessagesPage from './pages/DisasterMessagesPage';
import MissingPersonRegistrationPage from './pages/MissingPersonRegistrationPage';
import DeviceControlPage from './pages/DeviceControlPage';
import WeatherPage from './pages/WeatherPage';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/missing-persons" element={<MissingPersonsPage />} />
            <Route path="/missing-person-registration" element={<MissingPersonRegistrationPage />} />
            <Route path="/disaster-messages" element={<DisasterMessagesPage />} />
            <Route path="/device-control" element={<DeviceControlPage />} />
            <Route path="/weather" element={<WeatherPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;